import { render, staticRenderFns } from "./add-square.vue?vue&type=template&id=d21b7c7c&"
import script from "./add-square.vue?vue&type=script&lang=js&"
export * from "./add-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports